import styled, { css } from 'styled-components';

import { styledLayout, styledReset } from '@pkg/primitives';

import { commonCssVars, commonCssVarsDark, navCssVars, navCssVarsDark } from './styles-vars';
import { tokens } from './tokens';

interface StyledEmojiPickerProps {
    $darkMode?: boolean;
}

interface MainSectionProps {
    $scrollable?: boolean;
}

export const StyledEmojiPicker = styled.div<StyledEmojiPickerProps>`
    ${styledReset.borderBox};
    ${({ $darkMode }) => ($darkMode ? commonCssVarsDark : commonCssVars)};
    ${({ $darkMode }) => ($darkMode ? navCssVarsDark : navCssVars)};

    width: ${tokens.nav.getTotalWidth()}px;
`;

export const Header = styled.div``;

export const SearchWrapper = styled.div`
    padding-top: ${tokens.common.padding}px;
    padding-right: ${tokens.common.padding}px;
    padding-left: ${tokens.common.padding}px;
`;

export const NavigationWrapper = styled.div`
    padding: ${tokens.common.padding / 2}px;
`;

export const Main = styled.div``;

export const MainSection = styled.div<MainSectionProps>`
    display: grid;
    padding-top: ${tokens.common.padding / 4}px;
    padding-bottom: ${tokens.common.padding / 2}px;
    padding-right: ${tokens.common.padding}px;
    padding-left: ${tokens.common.padding}px;

    ${({ $scrollable }) =>
        $scrollable &&
        css`
            --yat_scrollbar-thumb-color: ${({ theme }) => theme.colors.purple};

            ${styledLayout.scrollbar({
                thumbColor: 'var(--yat_scrollbar-thumb-color)',
                trackColor: 'transparent',
            })};

            ${styledLayout.featherMask()};

            padding-top: ${tokens.common.padding / 2}px;
            padding-bottom: ${tokens.common.padding}px;
            height: ${tokens.mainSection.scrollableHeight}px;
            overflow-y: auto;
            overscroll-behavior-y: contain;
        `};
`;

export const CategoryTitle = styled.p`
    ${styledReset.typography};
    font-family: 'Alliance No.1';
    font-size: 12px;
    font-weight: 600;
    color: var(--yat_emoji-picker-common-color);
`;
